import {
  Component,
  Input,
  Output,
  EventEmitter,
  Optional,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
})
export class DialogComponent {
  @Input() dialogTitle: string = '';
  @Input() hideCloseButton: boolean = false;
  @Input() customClass: string = '';
  @Input() dialogWidth?: string;
  @Input() dialogMaxHeight?: string;
  @Output() closeClick = new EventEmitter<void>();

  constructor(@Optional() private dialogRef: MatDialogRef<any>) {}

  onCloseClick(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.closeClick.emit();
  }
}
